import SidebarApp from "./SidebarApp.svelte";
import CategoryApp from "./CategoryApp.svelte";
import SearchBarApp from "./SearchBarApp.svelte";
// src/i18n.js
import { addMessages } from "svelte-i18n";
import enUS_1 from "./locale/1/en-US.json";
import hr_1 from "./locale/1/hr.json";
import enUS_2 from "./locale/2/en-US.json";
import hr_2 from "./locale/2/hr.json";
import axios from "axios";
import { is_mobile } from "./lib/Mobile";
import "./lib/Log";
// console.log = a3_log;
axios.interceptors.request.use(function (config) {
    config.timeData = { startTime: new Date() };
    return config;
}, function (error) {
    return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
    const currTime = new Date();
    console.log(currTime, response.config.url, currTime.getTime() - response.config.timeData.startTime.getTime() + "ms");
    return response;
}, function (error) {
    return Promise.reject(error);
});
const partnerLocales = {
    1: { enUS: enUS_1, hr: hr_1 },
    2: { enUS: enUS_2, hr: hr_2 },
};
addMessages("en-US", partnerLocales[a3_elastic_index].enUS);
addMessages("hr", partnerLocales[a3_elastic_index].hr);
const isShop = document
    .getElementsByTagName("body")[0]
    .className.includes("woocommerce-page");
const sidebarTarget = document.getElementById("secondary");
const mobileSidebarTarget = document.getElementsByClassName("freshio-canvas-filter-wrap")[0];
let categoryTarget = document.getElementById("a3-products");
categoryTarget = categoryTarget
    ? categoryTarget
    : document.getElementById("primary");
console.log({ categoryTarget });
const searchBarTargets = document.getElementsByClassName("widget_product_search");
if (isShop &&
    sidebarTarget &&
    (!is_mobile() || (is_mobile && a3_elastic_index > 1))) {
    const sidebar = new SidebarApp({
        target: sidebarTarget,
        hydrate: true,
    });
}
if (mobileSidebarTarget && is_mobile()) {
    const sidebar = new SidebarApp({
        target: mobileSidebarTarget,
        hydrate: true,
    });
}
if (categoryTarget && typeof a3_query_vars !== "undefined") {
    const category = new CategoryApp({
        target: categoryTarget,
        hydrate: true,
        props: {
            query_vars: typeof a3_query_vars !== "undefined" ? a3_query_vars : [],
        },
    });
}
Array.from(searchBarTargets).forEach((searchBarTarget, index) => {
    const searchBar = new SearchBarApp({
        target: searchBarTarget,
        hydrate: true,
        props: {
            id: index,
        },
    });
});
